import { render, staticRenderFns } from "./Belong.vue?vue&type=template&id=b92c9d88&scoped=true"
import script from "./Belong.vue?vue&type=script&lang=js"
export * from "./Belong.vue?vue&type=script&lang=js"
import style0 from "./Belong.vue?vue&type=style&index=0&id=b92c9d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92c9d88",
  null
  
)

export default component.exports